import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import './SubMenu.css';

export default function SubMenu({ menuItems }) {
  //const [setUsername] = useState('');
  //const navigate = useNavigate();

  useEffect(() => {
    //const user = localStorage.getItem('username') || '';
    //setUsername(user);
  }, []);

  return (
    <header className='submenu-header'>
      <div>
        <nav className='submenu-navbar'>
          {menuItems.map((item, index) => (
            <Link key={index} to={item.path} className='nav-item-sub'>
              {item.label}
            </Link>
          ))}
        </nav>
      </div>
    </header>
  );
}